import React from 'react';
import {
  Button, Row, Col, Input
  , Collapse, Pagination, Table
  , Icon, DatePicker, Spin
} from 'antd';
import {inject, observer} from 'mobx-react';
import AppDatasBody from '../util/AppDatasBody';
import {toJS} from 'mobx';
import Navigation from '../public/navigation';
import AppApplyModal from '../util/AppApplyModal';

const Panel = Collapse.Panel;

@inject('homeStore')
@inject('orderStore')
@observer
class App extends React.Component {
  componentDidMount() {
    const {orderStore, location} = this.props;
    orderStore.callOrderData();
    orderStore.getRoutes(location.query);
  }

  //申请应用点击
  handleApplyClick() {
    const {orderStore} = this.props;
    orderStore.applyModal = {...orderStore.applyModal, visible: true};
  }

  //添加下拉框点击
  handleMenuClick(e) {
    const {orderStore} = this.props;
    if (e.key !== '') {
      if (e.key === '1') {
        orderStore.callToAddAPP("??todo:所选应用id", e.key)
      } else {
        orderStore.callAddWhereData(e.key)
        orderStore.addModal = {...orderStore.addModal, addWhere: e.key, visible: true};
      }
    }
  }

  //添加应用确认
  handleOk(key, name, type) {
    const {orderStore} = this.props;
    orderStore.callToAddAPP("??todo:所选应用id", key)
    orderStore.addModal = {...orderStore.addModal, visible: false};
  }

  render() {
    const server = window.server;
    const {orderStore, location, homeStore} = this.props;
    let {
      routes, routing, pagination, setPagination, searchValue
      , orderDatas, loadingOrder
    } = orderStore;
    pagination = toJS(pagination);
    orderDatas = toJS(orderDatas);
    const columns = [
      {
        key: '1',
        title: '表单名称',
        dataIndex: 'name',
        render(text, record, index) {
          return (
            <div>
              <div style={{display: 'inline-block'}}>
                <img src={server + record.s_pictureNati} className='list-table-img' alt=''/>
              </div>
              <div className='list-table-record' style={{display: 'inline-block'}}>
                <div style={{fontWeight: 600, cursor: 'pointer'}}
                     onClick={() => {
                       window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.s_wfid);
                     }}>{record.s_name}</div>
                <div className='list-table-record-sub'>
                  <Icon type="eye-o"/>
                  <span>{record.s_count}次</span>
                  <Icon type="download"/>
                  <span style={{color: '#ffab65'}}>{record.tms_isbuy_count}</span>次
                </div>
              </div>
            </div>
          )
        }
      },
      {
        key: '2',
        title: '操作',
        width: 150,
        render(text, record, index) {
          return (
            <div>
              {
                record && record.hpid
                  ? <span className='list-table-btn'
                          onClick={() =>
                            window.open("http://203.110.166.54:8085/homepage/Homepage.jsp?subCompanyId=25&showbtn=0&isfromportal=1&hpid=" + record.hpid)}>
                     预览</span>
                  : <span className='list-table-btn'
                          onClick={() =>
                            window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.workflowid)}>
                     预览</span>
              }
              <span className='list-table-btn'
                    style={{paddingRight: 24}}
                    onClick={() => {
                      let param = {sw_id: record.sw_id, s_id: record.s_id};
                      let appInfo = [{appId: record.s_number, appName: record.s_name}];
                      homeStore.getApply(param, appInfo);
                    }}>获取</span>
            </div>
          )
        }
      }
    ];
    return (
      <div className='order'>
        <AppDatasBody location={location}>
          <Navigation datas={toJS(routes)} onClick={(obj) => {
            if (obj.path)
              routing.push({
                pathname: obj.path,
                query: {
                  id: location.query.id,
                  radioType: location.query.radioType,
                  radioItem: location.query.radioItem,
                  radioSubItem: location.query.radioSubItem,
                }
              });
          }}/>
          <div className="cs-search-mylist">
            <Row>
              <Col span={17}>
                <Row>
                  <Col span={3} style={{paddingTop: 5}}> <label>表单名称：</label> </Col>
                  <Col span={7}>
                    <Input style={{marginRight:10,width:'90%'}} placeholder='请输入表单名称'
                           value={searchValue.appName}
                           onChange={(e) => {
                             orderStore.searchValue = {...searchValue, appName: e.target.value}
                           }}/>
                  </Col>
                  <Col span={7}>
                    <DatePicker
                      placeholder="请输入开始日期"
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime
                      style={{marginRight: 10,width:'90%'}}
                      value={searchValue.startDate}
                      onChange={date => {
                        searchValue.startDate = date;
                      }}
                    />
                  </Col>
                  <Col span={7}>
                    <DatePicker
                      placeholder="请输入结束日期"
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime
                      style={{width:'90%'}}
                      value={searchValue.endDate}
                      onChange={date => {
                        searchValue.endDate = date;
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={7}>
                <Col span={16} offset={8}>
                  <Button type="primary"
                          style={{marginRight:10}}
                          onClick={() => {
                            let startDate = searchValue.startDate && searchValue.startDate._d;
                            let endDate = searchValue.endDate && searchValue.endDate._d;
                            orderStore.callOrderData({
                              appName: searchValue.appName,
                              startDate: startDate,
                              endDate: endDate,
                            });
                          }}>搜索</Button>
                  <Button type="ghost"
                          onClick={() => {
                            orderStore.searchValue = {
                              appName: '',
                              startDate: null,
                              endDate: null,
                            };
                            orderStore.callOrderData();
                          }}>重置</Button>
                </Col>
              </Col>
            </Row>
            <Spin spinning={loadingOrder} style={{marginTop: -20}}>
              <div style={{marginTop: 30, minHeight: 200}}>
                {
                  !loadingOrder && orderDatas && orderDatas.length === 0 && (
                    <div className='order-no-data'>
                      <div className='icon-Cloud-No-data'/>
                      <div>暂无数据</div>
                    </div>
                  )
                }
                {
                  orderDatas && orderDatas.map((obj, index) => {
                    let end = obj.current * obj.pageSize;
                    let swList = toJS(obj.swList).slice(0, end);
                    return (
                      <Collapse style={{marginTop: 5}} key={obj.key}>
                        <Panel header={
                          <Row>
                            <Col span={12}>订单号：{obj.TM_Oid}</Col>
                            <Col span={8}>申请时间：{obj.TM_createtime}</Col>
                            <Col span={4}>订单状态：
                              {obj.TM_status === '0' && '驳回'}
                              {obj.TM_status === '1' && '申请'}
                              {obj.TM_status === '2' && '通过'}
                              {obj.TM_status === '5' && '审核'}
                            </Col>
                          </Row>
                        }>
                          <div style={{padding: '0 0 8px 15px'}}>
                            <Button disabled={!obj.selectedRows || obj.selectedRows.length === 0}
                                    onClick={() => {
                                      let sw_id = [], s_id = [], appInfo = [];
                                      obj.selectedRows.forEach(item => {
                                        sw_id.push(item.sw_id);
                                        s_id.push(item.s_id);
                                        appInfo.push({appId: item.s_number, appName: item.s_name});
                                      });
                                      let param = {sw_id: sw_id.toString(), s_id: s_id.toString()};
                                      homeStore.getApply(param, appInfo);
                                    }}>批量获取</Button>
                          </div>
                          <Table columns={toJS(columns)}
                                 dataSource={swList}
                                 className={`list-table order-list-table ${obj.selected && 'list-table2'}`}
                            // pagination={{
                            //   showSizeChanger: true,
                            //   showQuickJumper: true,
                            // }}
                                 pagination={false}
                                 locale={{
                                   emptyText:
                                     <div style={{fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center'}}>
                                       <Icon type="frown-o"/>
                                       <span style={{marginLeft: 4}}>暂无数据</span>
                                     </div>
                                 }}
                                 rowSelection={
                                   {
                                     type: 'checkbox',
                                     onChange: (selectedRowKeys, selectedRows) => {
                                       obj.selectedRowKeys = selectedRowKeys;
                                       obj.selectedRows = selectedRows;
                                       orderStore.orderDatas[index] = {
                                         ...obj,
                                         selected: selectedRows.length === toJS(obj.swList).length
                                       };
                                     },
                                     onSelectAll: selected => {
                                       orderStore.orderDatas[index] = {...obj, selected: selected};
                                     }
                                   }
                                 }/>
                          {
                            obj.hasMore && (
                              <div className='order-more'>
                                <div className='order-more-sub'>
                              <span onClick={() => {
                                orderStore.orderDatas[index].hasMore = (obj.current + 1) * obj.pageSize < toJS(obj.swList).length;
                                orderStore.orderDatas[index].current += 1;
                              }}>查看更多</span>
                                  <Icon type="double-right"/>
                                </div>
                              </div>
                            )
                          }
                        </Panel>
                      </Collapse>
                    )
                  })
                }
              </div>
            </Spin>
            <div style={{textAlign: 'right', paddingTop: 13}}>
              {
                pagination.total !== 0 && (
                  <Pagination {...pagination}
                              onChange={page => {
                                orderStore.callOrderData({current: page, ...location.query});
                                setPagination({...pagination, current: page});
                              }}
                              onShowSizeChange={(current, size) => {
                                orderStore.pagination.pageSize = size;
                                orderStore.pagination.current = 1;
                                orderStore.callOrderData();
                              }}
                  ></Pagination>
                )
              }
            </div>
          </div>
          <AppApplyModal applyModal={homeStore.applyModal}
                         applyApps={homeStore.applyApps}
                         handleCloseModal={() => {
                           homeStore.applyModal = {...homeStore.applyModal, visible: false}
                         }}
          />
        </AppDatasBody>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/order/Order.js